import { area } from '@turf/turf';
import { nanoid } from 'nanoid';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';
import { subscribe, useSnapshot } from 'valtio';
import { EditorMode, ProjectGeometryType } from '~/common/types';
import EditorSurface from '~/components2/Map/canvas/EditorSurface';
import { mapState } from '~/components2/Map/Map';
import store from './store';

const COLOR = {
  orange: 'orange',
  red: 'rgb(255, 0, 0)',
};

export default function EditorSurfaceComponent() {
  const map = useMap();
  const container = useRef<HTMLDivElement>(null);
  const { editorMode, geometryType } = useSnapshot(store) as typeof store;

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy
  useEffect(() => {
    if (container.current && map.current && editorMode !== EditorMode.None) {
      const surface = new EditorSurface({
        id: `edit-geometry-editor-surface-${nanoid()}`,
        container: container.current,
        map: map.current.getMap(),
        store: store,
      });

      const unsubscribe = subscribe(mapState, () => {
        surface.refreshScreenCoords();
      });

      const unsubscribeStore = subscribe(store, () => {
        if (!store.currentObject) return;

        if (geometryType === ProjectGeometryType.Small_3ac) {
          const ACRES_CONVERSION = 0.000247105;
          const areaInMeters = area(store.currentObject.geometry);
          const a = areaInMeters * ACRES_CONVERSION;
          store.projectArea = a;

          const exceeds = store.projectArea > store.projectAreaLimit;

          const color = exceeds === true ? COLOR.red : COLOR.orange;

          store.updateObject({ properties: { color } });
        }
      });

      return () => {
        unsubscribe();
        unsubscribeStore();
        surface.destroy();
      };
    }
  }, [editorMode]);

  if (!map.current) {
    return null;
  }

  if (editorMode === EditorMode.None) {
    return null;
  }

  return <div ref={container} style={{ cursor: '-moz-grab' }} className="absolute left-0 top-0"></div>;
}
